var exports = {
  "XA": "CommitGroup__cNK6VT",
  "BD": "Summary__3S29m4",
  "In": "Icon__vBpWxI",
};

module.exports = exports;
